//
import axios from "axios";
import StruttureMixin from "../../strutture/mixins/StruttureMixin";
import toast from "../../../template/layout/utility/sa-toast";
export default {
	inject: ["openShowModalLoading", "closeShowModalLoading"],
	mixins: [StruttureMixin],
	data() {
		return {

			contabilitaSoggettiPathResources: "/contabilitasoggetti",
			contabilitaSoggettoAltriIndirizziRighe: [],
			contabilitaSoggettoAltriIndirizziOptions: [],
			contabilitaSoggettoAltriIndirizziPathResources: "/contabilitasoggettoaltriindirizzi",
			filtroContabilitaSoggetti: {},
			contabilitaSoggettoTipologiePathResources: "/contabilitasoggettotipi",
			contabilitaSoggettoTipologieOptions: []
		};
	},
	methods: {
		resetItemsContabilitaSoggetti() {
			this.contabilitaSoggetti = [];
		},

		contabilitaSoggettoTipologieLoadData() {
			let link = process.env.VUE_APP_PATH_API + this.contabilitaSoggettoTipologiePathResources;
			this.contabilitaSoggettoTipologieOptions = [];
			axios.get(link)
				.then((response) => {
					this.contabilitaSoggettoTipologieOptions = response.data.data.list;
				})
				.catch((error) => {
					toast.error(error)
				});
		},


		// contabilitaSoggettiLoadData() {
		// 	let link = process.env.VUE_APP_PATH_API + this.contabilitaSoggettiPathResources;
		// 	axios.get(link, { params: this.filtroContabilitaSoggetti })
		// 		.then((response) => {
		// 			this.contabilitaSoggetti = response.data.data.list;
		// 			this.contabilitaSoggettiOptions = this.contabilitaSoggetti;
		// 		})
		// 		.catch((error) => {
		// 			toast.error(error);
		// 		});
		// },
		contabilitaSoggettoAltriIndirizziLoadData(filtro) {
			let link = process.env.VUE_APP_PATH_API + this.contabilitaSoggettoAltriIndirizziPathResources;
			this.contabilitaSoggettoAltriIndirizziOptions = [];
			axios.get(link, { params: filtro })
				.then((response) => {
					this.contabilitaSoggettoAltriIndirizziOptions = response.data.data.list;
				})
				.catch((error) => {
					toast.error(error)
				});
		},
	},
};
